"use strict";
/** Database table geometry as the table view and the live canvas renderer lay
 * it out (px). Server-side layout (AI canvas tools) and the renderer share
 * these values, so a server-placed table reserves the renderer's height. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANVAS_DATABASE_LIVE_CHROME_HEIGHT = exports.DATABASE_TABLE_ADD_COLUMN_WIDTH = exports.DATABASE_TABLE_ROW_GUTTER_WIDTH = exports.DATABASE_TABLE_STATS_BAR_HEIGHT = exports.CANVAS_DATABASE_ROW_WINDOW_FOOTER_HEIGHT = exports.CANVAS_DATABASE_TABLE_GROUP_FOOTER_HEIGHT = exports.DATABASE_TABLE_ROW_HEIGHT = exports.DATABASE_TABLE_HEADER_HEIGHT = exports.CANVAS_DATABASE_PRESENTATION_HEADER_HEIGHT = exports.CANVAS_DATABASE_PADDING_X = void 0;
exports.estimateCanvasDatabaseLiveTableHeight = estimateCanvasDatabaseLiveTableHeight;
/** Horizontal padding inside the canvas database block (left and right). */
exports.CANVAS_DATABASE_PADDING_X = 16;
/** Compact presentation header; equals the editor's compact header height. */
exports.CANVAS_DATABASE_PRESENTATION_HEADER_HEIGHT = 54;
/** Table column title row. */
exports.DATABASE_TABLE_HEADER_HEIGHT = 34;
/** One table row. */
exports.DATABASE_TABLE_ROW_HEIGHT = 36;
/** Group footer under the rows: "New Record" row and stats bar. */
exports.CANVAS_DATABASE_TABLE_GROUP_FOOTER_HEIGHT = 71;
/** Row-window footer under the table. */
exports.CANVAS_DATABASE_ROW_WINDOW_FOOTER_HEIGHT = 52;
/** Table stats bar. */
exports.DATABASE_TABLE_STATS_BAR_HEIGHT = 34;
/** Row drag gutter left of the table. */
exports.DATABASE_TABLE_ROW_GUTTER_WIDTH = 24;
/** Add-column cell right of the last column. */
exports.DATABASE_TABLE_ADD_COLUMN_WIDTH = 40;
exports.CANVAS_DATABASE_LIVE_CHROME_HEIGHT = exports.CANVAS_DATABASE_PRESENTATION_HEADER_HEIGHT +
    exports.DATABASE_TABLE_HEADER_HEIGHT +
    exports.CANVAS_DATABASE_TABLE_GROUP_FOOTER_HEIGHT +
    exports.CANVAS_DATABASE_ROW_WINDOW_FOOTER_HEIGHT;
/** Live table height for a row count, before the block's vertical padding. */
function estimateCanvasDatabaseLiveTableHeight(rowCount) {
    return (exports.CANVAS_DATABASE_LIVE_CHROME_HEIGHT + rowCount * exports.DATABASE_TABLE_ROW_HEIGHT);
}
